import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LeadcrmLayoutComponent } from './leadcrm-layout/leadcrm-layout.component';
import { LeadcrmDashboaardComponent } from './leadcrm-dashboaard/leadcrm-dashboaard.component';
import { LeadsComponent } from './leads/leads.component';
import { LeadsStatusComponent } from './leads-status/leads-status.component';
import { SmsTemplateComponent } from './settings/sms-template/sms-template.component';
import { EmailTemplateComponent } from './settings/email-template/email-template.component';


const routes: Routes = [
  { 
  	path: 'leadcrm', component: LeadcrmLayoutComponent, children: [
        { path: 'leads', component: LeadsComponent },
        { path: 'leads-status', component: LeadsStatusComponent },
        { path: 'settings', children: [
          { path: '', component: LeadsStatusComponent },
          { path: 'leads-status', component: LeadsStatusComponent },
          { path: 'sms-template', component: SmsTemplateComponent },
          { path: 'email-template', component: EmailTemplateComponent },
        ] },
      ]
    }
  ];

// const routes2: Routes = [
//   {
//     path: 'leadcrm', component: LeadcrmLayoutComponent, 
//     children: [
//       { path: '', component: LeadcrmDashboaardComponent },
//       {
//         path: 'leads', 
//         component: LeadsComponent,
//         data: { page: 'leads' }
//       },
//       {
//         path: 'leads-status', 
//         component: LeadsStatusComponent,
//         data: { page: 'leads-status' }
//       }
//     ]
//   }
// ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LeadCrmRoutingModule { }
